import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import ProjectDetail from './pages/ProjectDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Roadmap from './pages/Roadmap';
import Cv from './pages/Cv';

// Layout du site (header + footer). La roadmap et la page /cv sont des pages
// autonomes, avec leur propre système de design, rendues hors de ce layout.
function SiteLayout() {
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/profil" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/roadmap" element={<Roadmap />} />
        <Route path="/cv" element={<Cv />} />
        {/* Ancienne adresse de la page, conservée pour les liens déjà partagés. */}
        <Route path="/me" element={<Navigate to="/cv" replace />} />
        <Route path="/*" element={<SiteLayout />} />
      </Routes>
    </Router>
  );
}

export default App;
